import { render, staticRenderFns } from "./ProposalMaker.vue?vue&type=template&id=7009c8f0"
import script from "./ProposalMaker.vue?vue&type=script&lang=js"
export * from "./ProposalMaker.vue?vue&type=script&lang=js"
import style0 from "./ProposalMaker.vue?vue&type=style&index=0&id=7009c8f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports